/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Status_In_TreatmentInputs */

const en_us2_bodymap_status_in_treatment = /** @type {(inputs: Bodymap_Status_In_TreatmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still in treatment`)
};

const pt_br2_bodymap_status_in_treatment = /** @type {(inputs: Bodymap_Status_In_TreatmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda em tratamento`)
};

const es_419_bodymap_status_in_treatment = /** @type {(inputs: Bodymap_Status_In_TreatmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún en tratamiento`)
};

const pt_pt2_bodymap_status_in_treatment = /** @type {(inputs: Bodymap_Status_In_TreatmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda em tratamento`)
};

const fr_fr2_bodymap_status_in_treatment = /** @type {(inputs: Bodymap_Status_In_TreatmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encore en traitement`)
};

const de_de2_bodymap_status_in_treatment = /** @type {(inputs: Bodymap_Status_In_TreatmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch in Behandlung`)
};

const it_it2_bodymap_status_in_treatment = /** @type {(inputs: Bodymap_Status_In_TreatmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora in cura`)
};

/**
* | output |
* | --- |
* | "Still in treatment" |
*
* @param {Bodymap_Status_In_TreatmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_status_in_treatment = /** @type {((inputs?: Bodymap_Status_In_TreatmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Status_In_TreatmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_status_in_treatment(inputs)
	if (locale === "es-419") return es_419_bodymap_status_in_treatment(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_status_in_treatment(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_status_in_treatment(inputs)
	if (locale === "de-DE") return de_de2_bodymap_status_in_treatment(inputs)
	if (locale === "it-IT") return it_it2_bodymap_status_in_treatment(inputs)
	return en_us2_bodymap_status_in_treatment(inputs)
});
export { bodymap_status_in_treatment as "bodymap.status.in_treatment" }